




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({})
export default class skuViewChannelCode extends Vue {
  @Prop({ default: [] }) data;
  @Prop({ default: "" }) skuCode;
  visibleChannel = false;
}
